var scope_0 = require('/home/runner/work/primer.style/primer.style/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/694aeb97455ddae2fcf3b2c636290949.js').default;export default
        Object.assign({}, scope_0 )
    